import moment from "moment";
import * as R from 'ramda';
import {ensureArray} from 'ramda-adjunct';

export function codeProjection(path, codeTable) {
  return R.over(R.lensPath(path), code => codeTable[code] ? codeTable[code] : { name: code, code: code });
}

export function codeProjectionArray(path, codeTable) {
  return R.over(R.lensPath(path), list => list ? R.map(code => codeTable[code] ? codeTable[code] : { name: code, code: code }, list) : []);
}

export function codeProjectFromArray(path, codeTable) {
  return R.over(R.lensPath(path), code => codeTable.find(matching_code => matching_code.code === code) || { code, name: code });
}

export function categorize(list, field) {
  if (!list) {
    return [];
  }
  let categories = new Map();
  field = ensureArray(field);
  list.forEach(v => {
    if (R.hasPath(field, v)) {
      let fieldValue = R.view(R.lensPath(field), v);
      if (categories.has(fieldValue)) {
        categories.set(fieldValue, categories.get(fieldValue) + 1);
      } else {
        categories.set(fieldValue, 1);
      }
    }
  });
  return Array.from(categories.entries()).map(([k, v]) => ({key: k, value: v}));
}

export function buildSummaryChartData(items) {
  if (!items || items.length === 0) return null;
  return items
    .filter(item => item.key)
    .map(item => ({ value: item.value, name: item.key.name, itemStyle: { color: item.key.color } }));
}

export function convertToLocalDate(item) {
  if (!item) {
    return null;
  }
  if (item instanceof moment) {
    return item;
  }
  return moment(item);
}

export function convertToDate(item) {
  if (!item) {
    return null;
  }
  if (item instanceof moment) {
    return item;
  }
  return moment(item+'Z');
}

export function dateSort(path, descending) {
  if (descending)
    return (x2, x1) => {
      let p1 = R.path(path, x1);
      let p2 = R.path(path, x2);
      if (!p1 && !p2) return 0;
      if (!p1) return -1;
      if (!p2) return 1;
      return p1.diff(p2);
    };
  else
    return (x1, x2) => {
      let p1 = R.path(path, x1);
      let p2 = R.path(path, x2);
      if (!p1 && !p2) return 0;
      if (!p1) return -1;
      if (!p2) return 1;
      return p1.diff(p2);
    };
}



// WEBPACK FOOTER //
// ./src/projections.js